// Auto-approve is time-boxed so a granted permission cannot persist silently
// (SEC-06). Callers store the fields together and read activity via the check.
export const AUTO_APPROVE_TTL_MS = 60 * 60 * 1000;

export function isAutoApproveActive(connectedWallet) {
  return (
    !!connectedWallet?.autoApprove &&
    !!connectedWallet?.autoApproveExpiresAt &&
    Date.now() < connectedWallet.autoApproveExpiresAt
  );
}

export function autoApproveFields(enabled) {
  return enabled
    ? {
        autoApprove: true,
        autoApproveExpiresAt: Date.now() + AUTO_APPROVE_TTL_MS,
      }
    : { autoApprove: false, autoApproveExpiresAt: null };
}
